var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _c("page-search"),
      _c("page-table"),
      _c("sms-upload"),
      _c("LogModel", {
        attrs: {
          title: "短信导入",
          visible: _vm.showLog,
          active: "tripartiteResource",
        },
        on: { close: _vm.handleClose },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }